/* =========================================================
   Southern Made – bulk order popup  <sm-bulk-order>
   - Places the "Place your bulk order" button right under the
     add to cart (TeeInBlue #teeFormActions or the theme buy buttons)
   - Builds a quantity grid: sizes × colors, or one row per variant
   - Adds every chosen variant to the cart in one request, refreshes
     the cart drawer + count and opens the drawer
   - Respects the "SM Bulk order limit" section (sends to the bulk page)
   ========================================================= */
(function () {
  if (customElements.get('sm-bulk-order')) return;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || '${{amount}}';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  function updateCount(count) {
    document.querySelectorAll('.CartCountBubble').forEach(function (b) { b.classList.toggle('Visible', count > 0); });
    document.querySelectorAll('.CartCountBubble__Count, [data-cart-count]').forEach(function (c) {
      if (!c.classList.contains('VisuallyHidden')) c.textContent = count;
    });
  }

  var MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

  class SmBulkOrder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.data = JSON.parse(this.querySelector('[data-sm-bulk-data]').textContent); } catch (e) { return; }
      this.dialog = this.querySelector('dialog');
      this.grid = this.querySelector('[data-sm-bulk-grid]');
      this.countEl = this.querySelector('[data-sm-bulk-count]');
      this.totalEl = this.querySelector('[data-sm-bulk-total]');
      this.msgEl = this.querySelector('[data-sm-bulk-msg]');
      this.addBtn = this.querySelector('[data-sm-bulk-add]');
      this.trigger = this.querySelector('.SmBulk__Trigger');

      this.build();
      this.bind();
      this.place();
    }

    /* ---------- move the button under add to cart ---------- */
    place() {
      var self = this;
      var scope = this.closest('.SmProduct') || this.closest('.ProductSummary') || document.body;
      var trigger = this.trigger;

      /* climb from el to the element sitting directly inside the buy buttons block,
         so the button lands OUTSIDE app markup (TeeInBlue redraws its own area) */
      function outside(el, block) {
        while (el && el.parentElement && el.parentElement !== block) el = el.parentElement;
        return el;
      }
      function visible(el) {
        if (!el || !el.isConnected) return false;
        var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
        return r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden';
      }
      /* the add to cart button shoppers actually see (apps sometimes hide the theme one and add their own) */
      function findAtc(block) {
        var forms = block.querySelectorAll('form[action*="/cart/add"]');
        var first = null;
        for (var f = 0; f < forms.length; f++) {
          var btns = forms[f].querySelectorAll('button[name="add"], button[type="submit"], input[type="submit"], .ProductForm__AddToCart');
          for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            if (b.closest('.shopify-payment-button, shopify-accelerated-checkout, .SmBulk__Trigger')) continue;
            if (visible(b)) return b;
            if (!first) first = b;
          }
        }
        return first;
      }
      function target() {
        var block = scope.querySelector('.Product__Block--buyButtons');
        var tee = scope.querySelector('#teeFormActions, .tee-form-actions');
        if (tee) {
          if (block && block.contains(tee)) return { el: outside(tee, block), kind: 'tee' };
          var root = tee.closest('#tee-artwork-form, .tee-campaign') || tee;
          return { el: root, kind: 'tee' };
        }
        if (!block) return null;
        /* next to the theme's add to cart button (50 / 50 row) */
        var atc = findAtc(block);
        if (atc) return { el: atc, kind: 'row' };
        /* fallback: right under "More payment options" (dynamic checkout), else under the add to cart form */
        var pay = block.querySelector('.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]');
        if (pay) return { el: pay, kind: 'pay' };
        var form = block.querySelector('form[action*="/cart/add"]');
        if (form) return { el: form, kind: 'pay' };
        return { el: block, kind: 'block', inside: true };
      }
      function move() {
        var t = target();
        if (!t || !t.el) {
          /* nothing to sit under yet: keep it visible at the end of the product info */
          if (!trigger.isConnected) self.insertAdjacentElement('beforebegin', trigger);
          return;
        }
        if (t.kind === 'row') {
          var atc = t.el;
          var row = atc.closest('.SmBuyRow') || (atc.form && atc.form.querySelector('.SmBuyRow')) || null;
          if (!row) {
            row = document.createElement('div');
            row.className = 'SmBuyRow';
            atc.parentNode.insertBefore(row, atc);
            row.appendChild(atc);
          }
          /* the row holds only the add to cart + bulk button; anything else an app put in
             here (file upload, its own button copy, notices) goes back above the row */
          if (atc.parentElement !== row) row.insertBefore(atc, row.firstChild);
          /* any other (old/duplicate) rows in this form: unwrap them */
          if (atc.form) Array.prototype.slice.call(atc.form.querySelectorAll('.SmBuyRow')).forEach(function (r2) {
            if (r2 === row) return;
            while (r2.firstChild) r2.parentNode.insertBefore(r2.firstChild, r2);
            r2.remove();
          });
          Array.prototype.slice.call(row.children).forEach(function (c) {
            if (c === atc || c === trigger) return;
            row.parentNode.insertBefore(c, row);
          });
          if (atc.form) Array.prototype.forEach.call(atc.form.querySelectorAll('.SmBuyRow__Atc'), function (b) { if (b !== atc) b.classList.remove('SmBuyRow__Atc'); });
          atc.classList.add('SmBuyRow__Atc');
          if (trigger.parentElement !== row || row.lastElementChild !== trigger) row.appendChild(trigger);
          trigger.classList.add('SmBulk__Trigger--row');
          trigger.classList.remove('SmBulk__Trigger--tee', 'SmBulk__Trigger--pay');
          return;
        }
        trigger.classList.remove('SmBulk__Trigger--row');
        if (t.inside) {
          if (trigger.parentElement !== t.el || t.el.lastElementChild !== trigger) t.el.appendChild(trigger);
        } else if (t.el.nextElementSibling !== trigger) {
          t.el.insertAdjacentElement('afterend', trigger);
        }
        trigger.classList.toggle('SmBulk__Trigger--tee', t.kind === 'tee');
        trigger.classList.toggle('SmBulk__Trigger--pay', t.kind === 'pay');
      }
      move();

      /* keep watching: apps and the theme re-render the buy area (variant change,
         TeeInBlue load) – put the button back whenever it is moved or removed */
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; move(); });
      });
      mo.observe(scope, { childList: true, subtree: true });
      window.addEventListener('pageshow', move);
    }

    /* ---------- grid ---------- */
    variantFor(values) {
      var vs = this.data.variants;
      for (var i = 0; i < vs.length; i++) {
        var o = vs[i].options, ok = true;
        for (var k = 0; k < values.length; k++) if (values[k] != null && o[k] !== values[k]) { ok = false; break; }
        if (ok) return vs[i];
      }
      return null;
    }

    stepper(v, label) {
      if (!v) return '<span class="SmBulk__Na" aria-hidden="true">–</span>';
      var off = !v.available;
      if (off && this.data.hideUnavailable) return '<span class="SmBulk__Na" aria-hidden="true">–</span>';
      var max = v.max != null ? ' max="' + v.max + '"' : '';
      return '<div class="SmBulk__Qty' + (off ? ' is-off' : '') + '">' +
        '<button type="button" data-step="-1" aria-label="Decrease ' + esc(label) + '"' + (off ? ' disabled' : '') + '>' + MINUS + '</button>' +
        '<input class="SmBulk__Num" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" maxlength="5"' + max.replace(' max=', ' data-max=') + ' value="0" data-variant-id="' + v.id + '" data-price="' + v.price + '" aria-label="' + esc(label) + ' quantity"' + (off ? ' disabled title="Sold out"' : '') + '>' +
        '<button type="button" data-step="1" aria-label="Increase ' + esc(label) + '"' + (off ? ' disabled' : '') + '>' + PLUS + '</button>' +
        '</div>';
    }

    swatch(val) {
      if (!val) return '';
      if (val.image) return '<span class="SmBulk__Dot" style="background-image:url(' + esc(val.image) + ')"></span>';
      if (val.color) return '<span class="SmBulk__Dot" style="background:' + esc(val.color) + '"></span>';
      return '';
    }

    build() {
      var d = this.data, opts = d.options || [], html = '';
      /* only options that actually change (skip "One Size", a repeated style name…) */
      var vary = [];
      opts.forEach(function (o, i) {
        var seen = {};
        d.variants.forEach(function (v) { seen[v.options[i]] = 1; });
        if (Object.keys(seen).length > 1) vary.push(i);
      });
      var sizeI = vary.indexOf(d.sizeIndex) >= 0 ? d.sizeIndex : -1;
      var colorI = d.colorIndex >= 0 ? d.colorIndex : -1;
      var rowIdx = -1, colIdx = -1;
      if (vary.length === 2) {
        rowIdx = sizeI >= 0 ? sizeI : vary[0];
        colIdx = vary[0] === rowIdx ? vary[1] : vary[0];
        if (sizeI < 0 && opts[rowIdx].values.length < opts[colIdx].values.length) { var t = rowIdx; rowIdx = colIdx; colIdx = t; }
      }

      var rows = [], cols = [];
      if (rowIdx >= 0) {
        var self0 = this;
        var hasV = function (r, c) { var vals = []; vals[rowIdx] = r.name; vals[colIdx] = c.name; return !!self0.variantFor(vals); };
        rows = opts[rowIdx].values; cols = opts[colIdx].values;
        cols = cols.filter(function (c) { return rows.some(function (r) { return hasV(r, c); }); });
        rows = rows.filter(function (r) { return cols.some(function (c) { return hasV(r, c); }); });
        if (cols.length < 2 || rows.length < 2) rowIdx = -1;
      }

      if (rowIdx >= 0) {
        html += '<div class="SmBulk__Scroll"><table class="SmBulk__Table SmBulk__Table--matrix"><thead><tr><th scope="col">' + esc(opts[rowIdx].name) + '</th>';
        cols.forEach(function (c) { html += '<th scope="col"><span class="SmBulk__ColHead">' + this.swatch(c) + esc(c.name) + '</span></th>'; }, this);
        html += '</tr></thead><tbody>';
        rows.forEach(function (r) {
          html += '<tr><th scope="row">' + this.swatch(r) + esc(r.name) + '</th>';
          cols.forEach(function (c) {
            var vals = [];
            vals[rowIdx] = r.name; vals[colIdx] = c.name;
            html += '<td>' + this.stepper(this.variantFor(vals), r.name + ' / ' + c.name) + '</td>';
          }, this);
          html += '</tr>';
        }, this);
        html += '</tbody></table></div>';
      } else {
        /* one row per variant, labelled only with the options that change */
        var head = vary.length === 1 ? opts[vary[0]].name : (vary.length ? vary.map(function (i) { return opts[i].name; }).join(' / ') : 'Product');
        html += '<table class="SmBulk__Table SmBulk__Table--list"><thead><tr><th scope="col">' + esc(head) +
          '</th><th scope="col">Price</th><th scope="col">Quantity</th></tr></thead><tbody>';
        d.variants.forEach(function (v) {
          if (!v.available && d.hideUnavailable) return;
          var label = vary.length ? vary.map(function (i) { return v.options[i]; }).join(' / ') : d.productTitle;
          var sw = '';
          if (colorI >= 0 && opts[colorI]) {
            var val = opts[colorI].values.filter(function (x) { return x.name === v.options[colorI]; })[0];
            sw = this.swatch(val);
          }
          html += '<tr><th scope="row">' + sw + esc(label) + (v.available ? '' : ' <small>Sold out</small>') + '</th>' +
            '<td class="SmBulk__Price">' + formatMoney(v.price, d.moneyFormat) + '</td>' +
            '<td>' + this.stepper(v, label) + '</td></tr>';
        }, this);
        html += '</tbody></table>';
      }
      this.grid.innerHTML = html;
    }

    /* ---------- events ---------- */
    bind() {
      var self = this;
      this.querySelector('.SmBulk__Open').addEventListener('click', function () { self.open(); });
      this.querySelectorAll('[data-sm-bulk-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
      this.dialog.addEventListener('close', function () { document.documentElement.classList.remove('SmBulk-open'); self.unmountUploader(); });
      this.dialog.addEventListener('cancel', function () { document.documentElement.classList.remove('SmBulk-open'); });

      this.grid.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-step]');
        if (!b) return;
        var input = b.parentElement.querySelector('input');
        var max = input.dataset.max ? parseInt(input.dataset.max, 10) : Infinity;
        var n = Math.min(max, Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10)));
        input.value = n;
        self.update();
      });
      this.grid.addEventListener('input', function (e) {
        var i = e.target;
        if (i.matches && i.matches('.SmBulk__Num')) {
          var clean = i.value.replace(/\D+/g, '');
          if (clean !== i.value) i.value = clean;
        }
        self.update();
      });
      this.grid.addEventListener('keydown', function (e) {
        var i = e.target;
        if (!i.matches || !i.matches('.SmBulk__Num')) return;
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault();
          var max = i.dataset.max ? parseInt(i.dataset.max, 10) : Infinity;
          i.value = Math.min(max, Math.max(0, (parseInt(i.value, 10) || 0) + (e.key === 'ArrowUp' ? 1 : -1)));
          self.update();
        }
      });
      this.grid.addEventListener('focusout', function (e) {
        var i = e.target;
        if (i.matches && i.matches('.SmBulk__Num') && i.value === '') { i.value = 0; self.update(); }
      });
      this.grid.addEventListener('change', function (e) {
        var i = e.target;
        if (!i.matches('input')) return;
        var n = Math.max(0, parseInt(i.value, 10) || 0);
        if (i.dataset.max) n = Math.min(n, parseInt(i.dataset.max, 10));
        i.value = n;
        self.update();
      });
      this.grid.addEventListener('focusin', function (e) { if (e.target.matches('.SmBulk__Num') && e.target.value === '0') e.target.select(); });

      this.querySelector('[data-sm-bulk-clear]').addEventListener('click', function () {
        self.grid.querySelectorAll('input').forEach(function (i) { i.value = 0; });
        self.update();
      });
      this.addBtn.addEventListener('click', function () { self.submit(); });
      this.bindDrop();
    }

    /* ---------- artwork upload ---------- */
    productForm() {
      var scope = this.closest('.SmProduct') || document;
      var forms = scope.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) if (!forms[i].closest('.SmBulk')) return forms[i];
      return null;
    }
    appUploader() {
      var form = this.productForm();
      var scope = form || this.closest('.SmProduct') || document;
      var el = scope.querySelector('.upload-container, [class*="cl-upload--wrapper"], [data-upload-field], .uploadkit, .product-upload-field');
      if (!el) return null;
      /* take the outer box of the app */
      var outer = el.closest('.upload-container') || el;
      return outer;
    }
    mountUploader() {
      var slot = this.querySelector('[data-sm-bulk-appslot]');
      var drop = this.querySelector('[data-sm-bulk-drop]');
      if (!slot) return;
      var up = this._appUp && this._appUp.isConnected ? this._appUp : this.appUploader();
      if (up && !slot.contains(up)) {
        this._appUp = up;
        this._appMark = document.createComment('sm-bulk-uploader');
        up.parentNode.insertBefore(this._appMark, up);
        slot.appendChild(up);
      }
      var usingApp = !!(this._appUp && slot.contains(this._appUp));
      slot.hidden = !usingApp;
      if (drop) drop.hidden = usingApp;
    }
    unmountUploader() {
      if (this._appUp && this._appMark && this._appMark.parentNode) {
        this._appMark.parentNode.insertBefore(this._appUp, this._appMark);
        this._appMark.remove();
      }
      this._appMark = null;
    }
    bindDrop() {
      var self = this, drop = this.querySelector('[data-sm-bulk-drop]');
      if (!drop) return;
      var input = drop.querySelector('[data-sm-bulk-file]');
      var text = drop.querySelector('[data-sm-bulk-drop-text]');
      var rm = drop.querySelector('[data-sm-bulk-file-remove]');
      var original = text.innerHTML;
      function show() {
        var f = input.files && input.files[0];
        if (f && f.size > 20 * 1024 * 1024) { input.value = ''; self.msg('That file is over 20 MB – please choose a smaller file.', 'error'); f = null; }
        text.innerHTML = f ? '<strong></strong>' : original;
        if (f) text.querySelector('strong').textContent = f.name;
        drop.classList.toggle('has-file', !!f);
        rm.hidden = !f;
      }
      input.addEventListener('change', show);
      rm.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); input.value = ''; show(); });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) {
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        try { var dt = new DataTransfer(); dt.items.add(files[0]); input.files = dt.files; } catch (err) {}
        show();
      });
    }

    open() {
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('SmBulk-open');
      this.mountUploader();
      this.update();
      var first = this.grid.querySelector('input:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }

    close() {
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
      else this.dialog.removeAttribute('open');
      this.unmountUploader();
      document.documentElement.classList.remove('SmBulk-open');
    }

    items() {
      var out = [];
      this.grid.querySelectorAll('input[data-variant-id]').forEach(function (i) {
        var q = parseInt(i.value, 10) || 0;
        if (q > 0) out.push({ id: Number(i.dataset.variantId), quantity: q, price: Number(i.dataset.price) });
      });
      return out;
    }

    limitInfo(count) {
      var bl = window.SmBulkLimit;
      if (!bl || !bl.config || !bl.config.enabled || !bl.config.url) return null;
      var cfg = bl.config, cart = (bl.cart && bl.cart()) || { item_count: 0, items: [] };
      var already = cart.item_count || 0;
      if (cfg.mode === 'product') {
        already = 0;
        (cart.items || []).forEach(function (it) { if (String(it.product_id) === String(this.data.productId)) already += it.quantity; }, this);
      }
      var total = already + count;
      return total > cfg.limit ? { total: total, cfg: cfg } : null;
    }

    update() {
      var items = this.items(), count = 0, total = 0;
      items.forEach(function (it) { count += it.quantity; total += it.quantity * it.price; });
      this.countEl.textContent = count;
      this.totalEl.textContent = formatMoney(total, this.data.moneyFormat);
      this.grid.querySelectorAll('.SmBulk__Qty').forEach(function (q) {
        var i = q.querySelector('input');
        q.classList.toggle('is-set', (parseInt(i.value, 10) || 0) > 0);
      });
      this.addBtn.disabled = count === 0;
      this.over = this.limitInfo(count);
      if (this.over) {
        this.msg('Orders over ' + this.over.cfg.limit + ' items are handled on our bulk order page – we\'ll take your quantities with you.', 'info');
        this.addBtn.textContent = 'Continue to bulk order page';
      } else {
        this.msg('');
        this.addBtn.textContent = this.data.addLabel;
      }
    }

    msg(text, type) {
      this.msgEl.textContent = text || '';
      this.msgEl.hidden = !text;
      this.msgEl.className = 'SmBulk__Msg' + (type ? ' SmBulk__Msg--' + type : '');
    }

    /* line item properties for every bulk item:
       order notes + all properties[...] the product form holds (upload app, product options app) */
    properties() {
      var p = {}, files = [];
      var notes = this.querySelector('[data-sm-bulk-notes]');
      var sources = [];
      var form = this.productForm();
      if (form) sources.push(form);
      var slot = this.querySelector('[data-sm-bulk-appslot]');
      if (slot) sources.push(slot);
      sources.forEach(function (src) {
        src.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var key = el.name.slice(11, -1);
          if (!key || el.disabled) return;
          if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
          if (el.type === 'file') {
            if (el.files && el.files[0]) files.push({ key: key, file: el.files[0] });
            return;
          }
          var v = (el.value || '').trim();
          if (v !== '') p[key] = v;
        });
      });
      var own = this.querySelector('[data-sm-bulk-file]');
      var drop = this.querySelector('[data-sm-bulk-drop]');
      if (own && drop && !drop.hidden && own.files && own.files[0]) files.push({ key: 'Artwork', file: own.files[0] });
      if (notes && notes.value.trim()) p['Order notes'] = notes.value.trim();
      p['_Bulk order'] = 'Yes';
      return { props: p, files: files };
    }

    refreshDrawer() {
      var drawerSection = document.getElementById('shopify-section-cart-drawer');
      if (!drawerSection) return Promise.resolve();
      return fetch(ROOT + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j['cart-drawer']) return;
          var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
          var fresh = doc.getElementById('shopify-section-cart-drawer');
          drawerSection.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        })
        .catch(function () {});
    }

    submit() {
      var self = this, items = this.items();
      if (!items.length || this.addBtn.classList.contains('is-loading')) return;

      if (this.over) {
        var u = new URL(this.over.cfg.url, window.location.origin);
        if (this.over.cfg.passDetails !== false) {
          u.searchParams.set('quantity', this.over.total);
          u.searchParams.set('product', this.data.productTitle);
          u.searchParams.set('reason', 'bulk');
        }
        window.location.href = u.toString();
        return;
      }

      var collected = this.properties();
      var props = collected.props;
      var drawerSection = document.getElementById('shopify-section-cart-drawer');

      this.addBtn.classList.add('is-loading');
      this.addBtn.disabled = true;
      this.msg('');

      function json(r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); }

      var chain;
      if (collected.files.length) {
        /* 1st item as a normal form post with the file(s) – Shopify stores the file and returns its link */
        var first = items[0];
        var fd = new FormData();
        fd.append('id', first.id);
        fd.append('quantity', first.quantity);
        Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
        collected.files.forEach(function (f) { fd.append('properties[' + f.key + ']', f.file, f.file.name); });
        self.msg('Uploading your file…', 'info');
        chain = fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(json)
          .then(function (line) {
            var withLinks = Object.assign({}, props);
            var lp = (line && line.properties) || {};
            collected.files.forEach(function (f) { if (lp[f.key]) withLinks[f.key] = lp[f.key]; });
            var rest = items.slice(1);
            if (!rest.length) return self.refreshDrawer();
            var body = { items: rest.map(function (it) { return { id: it.id, quantity: it.quantity, properties: withLinks }; }) };
            if (drawerSection) body.sections = 'cart-drawer';
            return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
              .then(json).then(function (res) { return res; });
          });
      } else {
        var body = { items: items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: props }; }) };
        if (drawerSection) body.sections = 'cart-drawer';
        chain = fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
      }

      chain
        .then(function (res) {
          if (res && res.sections && res.sections['cart-drawer'] && drawerSection) {
            var doc = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
            var fresh = doc.getElementById('shopify-section-cart-drawer');
            drawerSection.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
          }
          return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          self.grid.querySelectorAll('input').forEach(function (i) { i.value = 0; });
          var own = self.querySelector('[data-sm-bulk-file]');
          if (own && own.value) { own.value = ''; own.dispatchEvent(new Event('change')); }
          self.update();
          self.close();
          var trigger = document.querySelector('#Header__CartTrigger[data-tg-toggle="Drawer"], [data-tg-target="#CartDrawer"]');
          if (trigger) trigger.click();
          else window.location.href = ROOT + 'cart';
        })
        .catch(function (err) {
          self.msg(err.message, 'error');
        })
        .finally(function () {
          self.addBtn.classList.remove('is-loading');
          self.addBtn.disabled = self.items().length === 0;
        });
    }
  }

  customElements.define('sm-bulk-order', SmBulkOrder);
})();
